import React, { useState } from 'react';
import { initializeIcons } from '@fluentui/react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import './App.css';
import { IWithErrorHandlingProps } from './components/withErrorHandling';
import { IDataServices } from './types';
import { AppGlobals } from './AppGlobals';
import { ZedXMainApp } from './ZedXMainApp';
import { Login } from './Login';

initializeIcons();
Intl.DateTimeFormat().resolvedOptions().timeZone = 'UTC'; // Set timezone

export interface IOrbProps extends IWithErrorHandlingProps {
  dataServices: IDataServices;
  onLogout?: () => void;
}

const App: React.FunctionComponent<IOrbProps> = (props: IOrbProps) => {

  const [userLoggedInAndSelected, setUserLoggedInAndSelected] = useState<boolean>(false);

  const handleLoginSuccess = () => {
    setUserLoggedInAndSelected(true);
  };

  const handleLogout = () => {
    AppGlobals.UserID = null;
    AppGlobals.Username = null;
    AppGlobals.UserTitle = null;
    AppGlobals.CustomJwtToken = null;
    AppGlobals.CustomerID = null;
    AppGlobals.CustomerTitle = null;
    setUserLoggedInAndSelected(false);
    window.location.href = '/';

  };

  const renderApps = (
    <HashRouter>
      <Switch>
        <Route
          exact
          path={["/", "/sectors/:any*", "/servers/:any*", "/customers/:any*", "/customer-users/:any*", "/apps/:any*"]} // Specify multiple paths
          render={({ match }) => {
            return (
              <ZedXMainApp
                onLogout={handleLogout}
                {...props}
              />
            );
          }}
        />

      </Switch>
    </HashRouter>
  );

  return (
    <React.Fragment>
      {userLoggedInAndSelected ? (
        renderApps
      ) : (
        <Login
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </React.Fragment>
  );

};
export default App;